import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Stack,
  Typography
} from "@mui/material";
import { updateBank } from "../../../../../services/dashboard/banks";

const EditBankForm = ({ bank, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    id: bank.id,
    name: bank.name,
    type: bank.type,
    discount_percentage: bank.discount_percentage,
    account_number: bank.account_number || ""
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const updated = await updateBank(form);
      onSuccess(updated);
      onClose();
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!bank} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>تعديل بيانات الحساب</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            label="اسم الحساب"
            name="name"
            value={form.name}
            onChange={handleChange}
            fullWidth
          />
          <FormControl fullWidth>
            <InputLabel>نوع الحساب</InputLabel>
            <Select name="type" value={form.type} onChange={handleChange}>
              <MenuItem value="bank">خزنة</MenuItem>
              <MenuItem value="bank_account">بنك</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="رقم الحساب"
            name="account_number"
            value={form.account_number}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="النسبة (%)"
            name="discount_percentage"
            type="number"
            value={form.discount_percentage}
            onChange={handleChange}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>إلغاء</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "حفظ التعديلات"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditBankForm;
